import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import classnames from 'classnames';

const propTypes = {
  isComplete: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  classes: PropTypes.shape({}).isRequired,
};

const defaultProps = {
  children: null,
};

export function UnstyledOverviewStep({ isComplete, title, children, classes }) {
  const thisClasses = isComplete
    ? classnames(classes.check, classes.checkActive)
    : classnames(classes.check, classes.checkInactive);
  return (
    <div className={classes.step}>
      <div className={classes.stepTitle}>
        <CheckCircleIcon className={thisClasses} />
        <Typography className={classes.title} variant="h6">
          {title}
        </Typography>
      </div>
      {children}
    </div>
  );
}

UnstyledOverviewStep.defaultProps = defaultProps;
UnstyledOverviewStep.propTypes = propTypes;

const styles = (theme) => ({
  step: {
    display: 'inline-block',
    width: '27%',
    position: 'relative',
    top: theme.spacing(-4),
    verticalAlign: 'top',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      top: '0px',
    },
  },
  title: {
    color: theme.customColors.teal,
    display: 'inline-block',
    ...theme.typography.altTitle,
    fontSize: 18,
  },
  stepTitle: {
    [theme.breakpoints.down('sm')]: {
      display: 'None',
    },
  },
  check: {
    color: theme.customColors.orange,
    display: 'inline-block',
    marginBottom: theme.spacing(-0.5),
    paddingRight: theme.spacing(0.5),
    transition: 'opacity 250ms ease-in-out',
  },
  checkInactive: {
    opacity: 0,
  },
  checkActive: {
    opacity: 1,
  },
});

export default withStyles(styles)(UnstyledOverviewStep);
